import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const PIN_CARD_VARIANTS = ['default', 'outline', 'elevated'] as const;
export const PIN_CARD_PADDING = ['none', 'sm', 'md', 'lg'] as const;

export type PinCardVariant = typeof PIN_CARD_VARIANTS[number];
export type PinCardPadding = typeof PIN_CARD_PADDING[number];

function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

const baseClasses = 'tw-rounded tw-border tw-bg-white tw-shadow-sm';

const variantClasses: Record<PinCardVariant, string> = {
  default: 'tw-border-gray-200',
  outline: 'tw-border-primary',
  elevated: 'tw-border-transparent tw-shadow-md',
};

const paddingClasses: Record<PinCardPadding, string> = {
  none: '',
  sm: 'tw-p-3',
  md: 'tw-p-5',
  lg: 'tw-p-8',
};

export function pinCardClasses({
  variant = 'default',
  padding = 'md',
}: {
  variant?: PinCardVariant;
  padding?: PinCardPadding;
}): string {
  return cn(baseClasses, variantClasses[variant], paddingClasses[padding]);
}
